import { render, staticRenderFns } from "./Prequiz.vue?vue&type=template&id=2e68e89a&scoped=true&"
import script from "./Prequiz.vue?vue&type=script&lang=js&"
export * from "./Prequiz.vue?vue&type=script&lang=js&"
import style0 from "./Prequiz.vue?vue&type=style&index=0&id=2e68e89a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68e89a",
  null
  
)

export default component.exports